var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list",attrs:{"data-type":"list"}},_vm._l((_vm.list),function(item,i){return _c('li',{key:i,staticClass:"list__item"},[_c('span',{staticClass:"grid-hide"}),_c('GameButton',{attrs:{"data":{
        value: i,
        type: 'list',
        content: item,
      }}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }